/* ==========================================================================
   PLP (spec 2026-10-02-filtros-por-marca-en-categorias).
   - PC: cada cambio en el lateral filtra al momento (GET a la URL resultante).
   - Móvil: el lateral es el panel «Filter»; ahí NO se filtra en cada toque, se
     aplica con «Show results» (submit del mismo formulario).
   - «Sort» del móvil: select fuera del formulario que conserva los demás parámetros.
   - Las categorías abren con «In stock» marcado (script en <head> de theme.liquid).
     Si el cliente lo quita, se recuerda en la sesión para no volver a ponérselo.
   Sin JS el <noscript> deja un botón de enviar y todo sigue funcionando.
   ========================================================================== */

(function () {
  'use strict';

  var STOCK_KEY = 'gyaaStockAll';
  var mqPanel = window.matchMedia('(max-width: 1023px)');

  function stockAll(on) {
    try {
      if (on) sessionStorage.setItem(STOCK_KEY, '1');
      else sessionStorage.removeItem(STOCK_KEY);
    } catch (e) {}
  }

  function submit(form) {
    var stock = form.querySelector('[data-plp-stock]');
    if (stock) stockAll(!stock.checked);

    var sortField = form.querySelector('[name="sort_by"]');
    var sortDefault = sortField ? sortField.getAttribute('data-default') : null;
    var clean = new URLSearchParams();
    new URLSearchParams(new FormData(form)).forEach(function (value, key) {
      if (value === '') return; // los rangos de precio vacíos ensucian la URL
      if (key === 'sort_by' && value === sortDefault) return; // el orden por defecto no hace falta
      clean.append(key, value);
    });
    var query = clean.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  /* --- Panel móvil ------------------------------------------------------- */

  var panel = document.querySelector('[data-plp-panel]');
  var bg = document.querySelector('.gyaa-plp__panel-bg');
  /* Puede haber dos botones que abren el panel: «Filter» y, en el diseño p3, «Brand»
     (que además lleva al grupo de marcas). Se recuerda cuál lo abrió para devolverle el foco. */
  var opener = null;

  function isOpen() {
    return panel && panel.classList.contains('is-open');
  }

  function openPanel(btn) {
    if (!panel) return;
    opener = btn || document.querySelector('[data-plp-open]');
    panel.classList.add('is-open');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    if (bg) bg.hidden = false;
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('gyaa-plp-lock');
    var close = panel.querySelector('.gyaa-plp__panel-close');
    if (close) close.focus();
    var foco = btn && btn.getAttribute('data-plp-focus');
    var grupo = foco === 'marca' ? panel.querySelector('[data-plp-marca]') : null;
    if (grupo) panel.scrollTop = Math.max(0, grupo.offsetTop - 16);
  }

  function closePanel() {
    if (!isOpen()) return;
    panel.classList.remove('is-open');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    if (bg) bg.hidden = true;
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
    document.documentElement.classList.remove('gyaa-plp-lock');
  }

  document.addEventListener('click', function (event) {
    var abre = event.target.closest('[data-plp-open]');
    if (abre) {
      openPanel(abre);
      return;
    }
    if (event.target.closest('[data-plp-close]')) {
      closePanel();
      return;
    }
    if (event.target.closest('[data-plp-stock-off]')) stockAll(true);
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      closePanel();
      return;
    }
    // Foco atrapado dentro del panel mientras está abierto.
    if (event.key === 'Tab') {
      var items = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select');
      var visible = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Si se pasa a PC con el panel abierto (girar la tablet), se cierra.
  var onMq = function (e) { if (!e.matches) closePanel(); };
  if (mqPanel.addEventListener) mqPanel.addEventListener('change', onMq);
  else if (mqPanel.addListener) mqPanel.addListener(onMq);

  /* --- Formulario --------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var field = event.target;

    if (field.matches('[data-plp-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', field.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }

    if (!field.matches('[data-plp-auto]')) return;
    // En el panel (móvil) se aplica con «Show results», no en cada toque.
    if (mqPanel.matches) return;
    var form = field.closest('[data-plp-filters]');
    if (form) submit(form);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-plp-filters]')) return;
    event.preventDefault();
    submit(form);
  });

  /* --- Fila de logos de marca (diseños p1 y p2; lote del 7-oct-2026) -------
     - Con ratón, en todas las categorías y en cualquier ancho: los logos pasan solos en un bucle continuo
       (detrás van copias inertes para que no haya salto ni hueco) y se paran con el ratón encima o con el
       foco del teclado. Las flechas adelantan. 19-oct-2026, Robert: «en todas las categorías deben moverse
       las marcas», también si caben todas y con «reducir movimiento» (como la marquesina desde el 24-sep).
     - Celular y tablet táctil: quietos; se pasan con el dedo (scroll nativo).
     - La marca elegida se ve al cargar, sin tener que deslizar. */

  var track = document.querySelector('[data-plp-logos-track]');
  var rail = track && track.querySelector('[data-plp-logos-rail]');
  if (track && rail && rail.children.length) {
    var flechas = document.querySelector('.gyaa-plp__logos-arrows');
    var mqMarquee = window.matchMedia('(hover: hover) and (pointer: fine)');
    var VELOCIDAD = 40; // px por segundo
    var originales = Array.prototype.slice.call(rail.children);
    var activo = rail.querySelector('.gyaa-plp__logo.is-active');
    var bucle = null; // estado mientras pasan solos

    var mod = function (x, m) { return ((x % m) + m) % m; };
    // Posición de un logo dentro del riel y ancho de una vuelta (todos los logos + un hueco).
    var posDe = function (el) { return el.offsetLeft - originales[0].offsetLeft; };
    var hueco = function () { return parseFloat(getComputedStyle(rail).columnGap) || 0; };
    var anchoVuelta = function () {
      var ultimo = originales[originales.length - 1];
      return posDe(ultimo) + ultimo.offsetWidth + hueco();
    };
    // Copias detrás de la fila: las que hagan falta para que, con la fila corrida una vuelta entera, la
    // fila siga llena hasta el borde derecho (con pocas marcas, varias).
    var copiasPara = function (ancho) { return Math.max(1, Math.ceil((track.clientWidth + hueco()) / ancho)); };

    var paso = function (t) {
      var b = bucle;
      if (!b) return;
      var dt = b.t == null ? 0 : Math.min(64, t - b.t);
      b.t = t;
      if (b.empuje) {
        var k = Math.min(1, (t - b.empuje.t0) / b.empuje.dur);
        b.pos = b.empuje.desde + (b.empuje.hasta - b.empuje.desde) * (1 - Math.pow(1 - k, 3));
        if (k >= 1) b.empuje = null;
      } else if (!b.raton && !b.foco && b.visible) {
        b.pos += VELOCIDAD * dt / 1000;
      }
      if (!b.empuje) b.pos = mod(b.pos, b.ancho);
      var x = -mod(b.pos, b.ancho);
      if (x !== b.x) {
        b.x = x;
        rail.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      }
      b.raf = requestAnimationFrame(paso);
    };

    var arrancar = function () {
      var ancho = anchoVuelta();
      var copias = copiasPara(ancho);
      // Las copias se pueden pulsar (con el ratón encima la fila se para y puede quedar debajo una copia),
      // pero no entran en el tabulador ni en los lectores de pantalla.
      var clones = [];
      for (var k = 0; k < copias; k++) {
        originales.forEach(function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('tabindex', '-1');
          c.setAttribute('data-plp-clon', '');
          rail.appendChild(c);
          clones.push(c);
        });
      }
      track.classList.add('is-marquee');
      track.scrollLeft = 0;
      bucle = { ancho: ancho, copias: copias, pos: 0, x: null, t: null, raton: track.matches(':hover'), foco: track.contains(document.activeElement), visible: true, empuje: null, clones: clones, raf: 0 };
      if (activo) bucle.pos = Math.max(0, posDe(activo) - 24);
      bucle.raf = requestAnimationFrame(paso);
    };

    var parar = function () {
      if (!bucle) return;
      cancelAnimationFrame(bucle.raf);
      bucle.clones.forEach(function (c) { c.remove(); });
      rail.style.transform = '';
      track.classList.remove('is-marquee');
      bucle = null;
    };

    var ajustar = function () {
      if (mqMarquee.matches) {
        if (!bucle) arrancar();
        else {
          bucle.ancho = anchoVuelta();
          // Más ancha la fila (o más estrechos los logos): otra vez con las copias que hagan falta, en el mismo punto.
          if (copiasPara(bucle.ancho) !== bucle.copias) {
            var antes = bucle;
            parar();
            arrancar();
            bucle.pos = antes.pos;
            bucle.visible = antes.visible;
          }
        }
      } else {
        parar();
      }
      var desborda = !!bucle || rail.scrollWidth > track.clientWidth + 2;
      track.classList.toggle('is-overflow', !bucle && desborda);
      if (flechas) flechas.hidden = !desborda;
    };

    ajustar();
    window.addEventListener('resize', ajustar);
    if (mqMarquee.addEventListener) mqMarquee.addEventListener('change', ajustar);
    else if (mqMarquee.addListener) mqMarquee.addListener(ajustar);

    if (!bucle && activo && track.scrollWidth > track.clientWidth) {
      track.scrollLeft += activo.getBoundingClientRect().left - track.getBoundingClientRect().left - 20;
    }

    track.addEventListener('mouseenter', function () { if (bucle) bucle.raton = true; });
    track.addEventListener('mouseleave', function () { if (bucle) bucle.raton = false; });
    track.addEventListener('focusin', function (event) {
      if (!bucle) return;
      bucle.foco = true;
      // El logo con el foco tiene que verse entero (en su sitio o en la copia de detrás).
      var tile = event.target.closest('.gyaa-plp__logo');
      if (!tile || tile.hasAttribute('data-plp-clon')) return;
      var x = posDe(tile);
      var w = tile.offsetWidth;
      var m = mod(bucle.pos, bucle.ancho);
      var vw = track.clientWidth;
      var dentro = (x >= m && x + w <= m + vw) || (x + bucle.ancho >= m && x + bucle.ancho + w <= m + vw);
      if (!dentro) {
        bucle.empuje = null;
        bucle.pos = Math.max(0, x - 24);
      }
    });
    track.addEventListener('focusout', function (event) {
      if (bucle && !track.contains(event.relatedTarget)) bucle.foco = false;
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (bucle) bucle.visible = entries[0].isIntersecting;
      }).observe(track);
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-plp-logos]');
      if (!btn) return;
      var dir = parseInt(btn.getAttribute('data-plp-logos'), 10) || 1;
      var dist = dir * track.clientWidth * 0.8;
      if (bucle) {
        bucle.empuje = { desde: bucle.pos, hasta: bucle.pos + dist, t0: performance.now(), dur: 500 };
      } else {
        track.scrollBy({ left: dist, behavior: 'smooth' });
      }
    });
  }
})();
